export const PAYMENT_METHOD_LABELS = {
  cash: "מזומן",
  credit: "אשראי",
  transfer: "העברה",
  check: "צ׳ק",
  bit: "אפליקציה",
  punch_card: "כרטיסיה",
  other: "אחר",
};

export const PAYMENT_METHOD_COLORS = {
  cash: "#22c55e",
  credit: "#3b82f6",
  transfer: "#8b5cf6",
  check: "#f59e0b",
  bit: "#ec4899",
  punch_card: "#14b8a6",
  other: "#9ca3af",
};
